import * as React from 'react';

import { Col, Skeleton } from 'antd';
import { Row, Space } from 'farmhub-ui-core';

const EntityStockReportSkeleton = () => {
  const spaceHeight = 30;
  return (
    <Row alignItems="flex-start">
      <Col lg={24} style={{ gap: 12 }} xl={16}>
        <Row>
          <Skeleton.Input size="default" style={{ width: 170 }} />
          <Space width={200} />
          <Skeleton.Input size="default" style={{ width: 450 }} />
        </Row>
        <Space height={spaceHeight} />
        <Row>
          <Skeleton.Input size="default" style={{ width: 170 }} />
          <Space width={200} />
          <Skeleton.Input size="default" style={{ width: 450 }} />
        </Row>
        <Space height={spaceHeight} />
        <Row>
          <Skeleton.Input size="default" style={{ width: 170 }} />
          <Space width={200} />
          <Skeleton.Input size="default" style={{ width: 450 }} />
        </Row>
        <Space height={spaceHeight} />
        <Row>
          <Skeleton.Input size="default" style={{ width: 170 }} />
          <Space width={200} />
          <Skeleton.Input size="default" style={{ width: 450 }} />
        </Row>
        <Space height={spaceHeight} />
        <Row>
          <Skeleton.Input size="default" style={{ width: 170 }} />
          <Space width={200} />
          <Skeleton.Input size="default" style={{ width: 450 }} />
        </Row>
        <Space height={spaceHeight} />
        <Row>
          <Skeleton.Input size="default" style={{ width: 170 }} />
          <Space width={200} />
          <Skeleton.Input size="default" style={{ width: 450 }} />
        </Row>
        <Space height={spaceHeight} />
        <Row>
          <Skeleton.Input size="default" style={{ width: 170 }} />
          <Space width={200} />
          <Skeleton.Input size="default" style={{ width: 100 }} />
        </Row>
      </Col>
    </Row>
  );
};

export default EntityStockReportSkeleton;
